import { useDispatch, useSelector } from 'react-redux'
import { SelectCustom } from '../../../../common/selectCustom'
import { changeYear, selectTopYears, selectYear } from './store/slice'

export const FiscalYearSelect = () => {
  const dispatch = useDispatch()

  const topYears = useSelector(selectTopYears)
  const year = useSelector(selectYear)

  const chooseYearItem = (item) => {
    dispatch(changeYear(item))
  }

  return (
    <SelectCustom
      isBorderNone
      className="fw600"
      data={topYears.map((year) => ({ label: year, value: year }))}
      activeItem={year}
      isI18n
      chooseItem={chooseYearItem}
    />
  )
}
